/*
 * Requires the Terms checkbox (snippets/azm-terms-agree.liquid) before checkout,
 * in both the cart drawer and on /cart.
 *
 * The drawer's markup is replaced on every cart change (cart-drawer.js / cart.js),
 * so the agreed state is held here and re-applied after each re-render instead
 * of living on the input. Checkout buttons are never truly `disabled`: a click
 * must still reach us so we can explain why nothing happened.
 */
(function () {
  if (window.azmTermsAgree) return;
  window.azmTermsAgree = true;

  // form id -> element that contains that form's Terms checkbox
  var SCOPES = { 'CartDrawer-Form': '#CartDrawer', cart: '#main-cart-footer' };
  var agreed = false;

  function inputs() {
    return document.querySelectorAll('[data-azm-terms-input]');
  }

  function showError(scope, show) {
    var root = scope ? document.querySelector(scope) : document;
    if (!root) return;
    root.querySelectorAll('.azm-terms__error').forEach(function (el) {
      el.hidden = !show;
    });
    if (show) {
      var input = root.querySelector('[data-azm-terms-input]');
      if (input) input.focus();
    }
  }

  function sync() {
    inputs().forEach(function (input) {
      input.checked = agreed;
    });
    document.querySelectorAll('.cart__checkout-button').forEach(function (btn) {
      btn.classList.toggle('azm-terms-locked', !agreed);
      if (agreed) btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', 'true');
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      el.classList.toggle('azm-terms-locked', !agreed);
    });
    if (agreed) showError(null, false);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-azm-terms-input]')) return;
    agreed = e.target.checked;
    sync();
  });

  // Capture phase so this runs before the theme's own submit handlers.
  document.addEventListener(
    'submit',
    function (e) {
      var scope = SCOPES[e.target.id];
      if (!scope || agreed) return;
      var root = document.querySelector(scope);
      if (!root || !root.querySelector('[data-azm-terms]')) return;
      // Enter in a quantity field submits via the default (checkout) button, so
      // a missing submitter counts as a checkout attempt too.
      if (e.submitter && e.submitter.name !== 'checkout') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(scope, true);
    },
    true
  );

  // Express checkout (Shop Pay, etc.) can't be intercepted, so its buttons are
  // made unclickable via CSS while locked and the click lands on the wrapper.
  document.addEventListener(
    'click',
    function (e) {
      var wrap = e.target.closest && e.target.closest('.cart__dynamic-checkout-buttons.azm-terms-locked');
      if (!wrap) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('#main-cart-footer', true);
    },
    true
  );

  function observe() {
    sync();
    var observer = new MutationObserver(function () {
      // Only resync when a re-render brought back a checkbox out of step with state.
      var stale = Array.prototype.some.call(inputs(), function (input) {
        return input.checked !== agreed;
      });
      var lockedWrong = Array.prototype.some.call(
        document.querySelectorAll('.cart__checkout-button'),
        function (btn) {
          return btn.classList.contains('azm-terms-locked') === agreed;
        }
      );
      if (stale || lockedWrong) sync();
    });
    ['cart-drawer', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
